var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('p',[_c('a',{on:{"click":function($event){return _vm.$emit('showDisclaimer')}}},[_vm._v("Data Sources disclaimer")])])])}
var staticRenderFns = []

export { render, staticRenderFns }